var cur_grid = jQuery("#product-grid");
var nxt_url = cur_grid.data("nxt-url");
var page_count = cur_grid.data("pg-count");
var isLoading = false; // Add a flag to track whether the loader is already running

function infinteLoader() {
  if (isLoading) return; // Ignore subsequent calls until the current call is complete
  isLoading = true;

  console.log("entered");
  if (nxt_url) {
    jQuery.ajax({
      url: nxt_url,
      type: "GET",
      dataType: "html",
    }).done(function (nxt_pg) {
      var nxt_set_prdts = jQuery(nxt_pg).find("#product-grid");
      nxt_url = nxt_set_prdts.data("nxtUrl");

      cur_grid.append(nxt_set_prdts.html());

      // Call compareGridRender() after appending new product cards
      if (typeof compareGridRender != "undefined") {
        compareGridRender();
      }

      isLoading = false; // Reset the flag after the current call is complete
    });
  } else {
    jQuery(".sw-loader-container").css("display", "none");
    jQuery(".sw-loaded-container").css("display", "flex");
    isLoading = false; // Reset the flag after the current call is complete
  }
}

// Create the Intersection Observer callback
function onIntersection(entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      infinteLoader();
      // Optionally, unobserve the element if you only need to apply the function once
      //observer.unobserve(entry.target);
    }
  });
}

// Create the Intersection Observer instance
let observer = new IntersectionObserver(onIntersection, {
  root: null, // Use the viewport as the root
  threshold: 0.1, // Trigger when 10% of the element is visible
});

// Observe the loader element
let loaderElement = document.querySelector(".sw-loader-container");
if (loaderElement) {
  observer.observe(loaderElement);
}







